import { useTheme } from '@emotion/react'

interface IconProps {
  width: string
  height: string
  onClick?: () => void
}

export const PlayIcon = (props: IconProps) => {
  const theme = useTheme()

  return theme.playIcon ? (
    <img
      src={theme.playIcon}
      alt="play icon"
      width={props.width}
      height={props.height}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.36 16.3547L32.3562 24L19.36 31.6447V16.3547ZM18 14V34L35 24L18 14Z"
        fill="white"
      />
    </svg>
  )
}

export const PauseIcon = (props: IconProps) => {
  const theme = useTheme()

  return theme.pauseIcon ? (
    <img
      src={theme.pauseIcon}
      alt="pause icon"
      width={props.width}
      height={props.height}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1343_1933)">
        <path
          d="M25.7129 15.7715H32.7682V32.2286H25.7129V15.7715Z"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M14.731 15.7715H21.7862V32.2286H14.731V15.7715Z"
          stroke="white"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1343_1933">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const VolumeOffIcon = (props: IconProps) => {
  const theme = useTheme()

  return theme.muteIcon ? (
    <img
      src={theme.muteIcon}
      alt="volume off icon"
      width={props.width}
      height={props.height}
      onClick={props.onClick}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1343_1968)">
        <path
          d="M18.9893 18.5253L18.1016 19.2988C17.9748 19.4091 17.8083 19.4706 17.6357 19.4706H12.373V28.0986H17.6357C17.8178 28.0986 17.9924 28.1667 18.1211 28.288L22.8984 32.791V22.5781L24.2715 24.0019V34.3535C24.2714 34.6151 24.1041 34.851 23.8477 34.9511C23.5912 35.0512 23.2959 34.9955 23.0996 34.8105L17.3516 29.3925H11.6865C11.3074 29.3925 11 29.1024 11 28.7451V18.8232C11.0002 18.466 11.3076 18.1767 11.6865 18.1767H17.3672L18.0664 17.5673L18.9893 18.5253ZM33.5566 33.6318C33.4457 33.74 33.3331 33.8479 33.2178 33.954C32.9465 34.2036 32.5119 34.1979 32.2471 33.9423C31.9822 33.6867 31.9867 33.277 32.2578 33.0273C32.3853 32.91 32.5083 32.7898 32.6299 32.6699L33.5566 33.6318ZM30.9414 30.9199C30.7881 31.0713 30.6302 31.2221 30.4658 31.3701C30.1918 31.6166 29.758 31.6075 29.4961 31.3496C29.2343 31.0912 29.2437 30.6814 29.5176 30.4345C29.6908 30.2785 29.8553 30.1187 30.0146 29.9589L30.9414 30.9199ZM32.2051 13.2382C32.4444 12.9611 32.8769 12.9199 33.1709 13.1455C37.9899 16.8417 39.5171 24.0516 36.3066 30.0048L35.3115 28.9736C37.9396 23.624 36.4693 17.3439 32.3047 14.1494C32.0106 13.9238 31.9658 13.5154 32.2051 13.2382ZM28.7354 28.6318C28.5648 28.8269 28.3846 29.0192 28.1895 29.2031C27.9215 29.4557 27.4868 29.4555 27.2188 29.2031C26.9507 28.9504 26.9507 28.5407 27.2188 28.288C27.4311 28.0879 27.6235 27.8778 27.8008 27.663L28.7354 28.6318ZM29.4551 15.832C29.6912 15.5526 30.1234 15.5069 30.4199 15.7294C33.9961 18.4131 35.3356 22.9513 33.5537 27.1503L32.5078 26.0663C33.7088 22.552 32.469 18.9206 29.5645 16.7412C29.2681 16.5186 29.2191 16.1115 29.4551 15.832ZM27.1768 18.4091C27.4195 18.1348 27.8524 18.0974 28.1436 18.3261C29.846 19.6634 30.7395 21.8528 30.6094 24.0966L29.1533 22.5859C28.9155 21.2754 28.2536 20.0971 27.2646 19.3203C26.9735 19.0915 26.9341 18.6836 27.1768 18.4091ZM23.1191 13.1718C23.3195 12.9975 23.6106 12.9515 23.8604 13.0546C24.1101 13.1577 24.2715 13.3904 24.2715 13.6474V17.5234L22.8984 16.0986V15.1249L22.3867 15.5693L21.4639 14.6113L23.1191 13.1718Z"
          fill="white"
        />
        <path
          d="M17.749 14L37.0352 34.0004"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1343_1968">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const VolumeOnIcon = (props: IconProps) => {
  const theme = useTheme()

  return theme.unmuteIcon ? (
    <img
      src={theme.unmuteIcon}
      alt="volume on icon"
      width={props.width}
      height={props.height}
      onClick={props.onClick}
    />
  ) : (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1343_1938)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.8601 13.0543C24.1099 13.1574 24.2712 13.3901 24.2712 13.6471V34.3529C24.2712 34.6146 24.104 34.8506 23.8475 34.9507C23.591 35.0509 23.2957 34.9955 23.0994 34.8105L17.3513 29.3921H11.6864C11.3073 29.3921 11 29.1024 11 28.7451V18.8235C11 18.4662 11.3073 18.1765 11.6864 18.1765H17.3672L23.1192 13.1716C23.3195 12.9973 23.6103 12.9513 23.8601 13.0543ZM22.8983 15.1249L18.1012 19.299C17.9744 19.4093 17.8082 19.4706 17.6356 19.4706H12.3729V28.098H17.6356C17.8177 28.098 17.9923 28.1662 18.121 28.2875L22.8983 32.7908V15.1249Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1761 18.4093C27.4188 18.1348 27.8517 18.0977 28.1429 18.3265C31.2153 20.7398 31.6623 25.9285 28.1889 29.2026C27.9208 29.4553 27.4861 29.4553 27.2181 29.2026C26.95 28.9499 26.95 28.5402 27.2181 28.2876C30.1514 25.5225 29.6832 21.2209 27.264 19.3206C26.9728 19.0918 26.9334 18.6838 27.1761 18.4093Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.4546 15.8323C29.6907 15.5527 30.1225 15.5065 30.4191 15.7291C35.2567 19.3589 36.0038 26.3834 30.4658 31.3699C30.1916 31.6167 29.7571 31.6073 29.4952 31.3489C29.2334 31.0905 29.2433 30.6809 29.5175 30.4341C34.4777 25.9679 33.725 19.8636 29.5641 16.7416C29.2675 16.519 29.2184 16.1119 29.4546 15.8323Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.2049 13.2387C32.4442 12.9615 32.8766 12.9196 33.1706 13.1452C39.1288 17.7152 40.0568 27.6576 33.217 33.9531C32.9457 34.2028 32.5111 34.1979 32.2462 33.9422C31.9814 33.6866 31.9866 33.2769 32.2578 33.0272C38.5407 27.2443 37.5941 18.2064 32.3041 14.149C32.0101 13.9234 31.9657 13.5159 32.2049 13.2387Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1343_1938">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
